import CalendarEventsStore from '../../store/CalendarEventsStore';
import getCalendarEventKey from '../../utils/getCalendarEventKey';
import { CalendarEvent, CalendarEventKey } from 'mini-calendar-event-types';
import { getCalendarEventsStore } from '../../store/store';

/**
 * Internal method that deletes events to cache.
 * @param events - Events to delete.
 * @returns the calendar keys of events that were deleted.
 */
export default function deleteCalendarEventsFromCache(events: CalendarEvent[]): CalendarEventKey[] {
    const store: CalendarEventsStore = getCalendarEventsStore();
    const keys: CalendarEventKey[] = [];

    events.forEach(e => {
        store.deleteCalendarEvent(e);
        keys.push(getCalendarEventKey(e));
    });

    return keys;
}
